import { render } from "./XToastTaskDetail.vue?vue&type=template&id=8f4571fa&scoped=true"
import script from "./XToastTaskDetail.vue?vue&type=script&lang=js"
export * from "./XToastTaskDetail.vue?vue&type=script&lang=js"

import "./XToastTaskDetail.vue?vue&type=style&index=0&id=8f4571fa&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4571fa"]])

export default __exports__